import {Component, HostListener, OnInit} from '@angular/core';
import {ConfService} from '../conf.service';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {FilterPipe} from '../filter.pipe';
import {SearchByObject} from '../filter.pipe';
import {de} from 'cronstrue/dist/i18n/locales/de';
import {interval} from 'rxjs';
import {FormControl} from '@angular/forms';

declare let $;

@Component({
    selector: 'app-api-discovery',
    templateUrl: './api-discovery.component.html',
    styleUrls: ['./api-discovery.component.scss']
})
export class ApiDiscoveryComponent implements OnInit {

    searchText = '';
    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');
    apiList: any;
    filteredAPIList: any;
    entities: any;
    filteredEntities: any;
    b2bAPIs: any;
    filterPipe = new FilterPipe();
    searchByObject = new SearchByObject();
    serviceProviders: any;
    filteredb2bAPIs = [];
    b2bAPIsList = [];
    apiProducers = [];
    apiDependenciesList = [];
    dependencies = {};
    usages = {};
    settingsData: any;
    subscribedTemp: any;
    filteredSubscribedTemp: any;
    available = [];
    filteredAvailable = [];
    cardType = 'connectorAvl';
    buttonType = 'connector';
    title = 'All API Providers';
    title1 = 'My API Providers';
    cardType1 = 'connectorSubscribed';
    buttonType1 = 'connector';
    serviceProviderImages = {};
    loading = true;
    componentLoading = true;
    typingTimer: any;
    isSearching = true;
    filteredAPIListLimit = 4;
    filteredb2bAPIListLimit = 4;
    filteredEntitiesListLimit = 4;

    apiFromServiceProviders: any;
    apiFromDAS: any;
    apiCreatedInApiplatform: any;
    isEntityDefOpened = false;
    isAPIDefOpened = false;
    isAPIMgmtOpened = false;
    isAPIDocTabOpened = false;
    isUsagesOpened = false;
    isDependenciesOpened = false;
    tabsData = [];
    activeTabIndex: any;

    apiDiscoveryTypes = new FormControl('');
    apiDiscoveryList: string[] = ['-- All APIs --', 'Subscribed API Providers', 'Unsubscribed API Providers', 'Apiplatform.io APIs', 'Registered APIs', 'Data Access APIs'];
    selected = this.apiDiscoveryList[0];
    databases: any;

    constructor(public confPost: ConfService, public platform: LeftpanelComponent) {
    }


    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.tabsData = [];
        const permissionSubscription = interval(500).subscribe((async x => {
            this.componentLoading = false;
            permissionSubscription.unsubscribe();
            if (this.platform.hasPlatformPermission('VIEW_API_DISCOVERY')) {
                if (this.platform.apiList !== null && this.platform.apiList !== undefined) {
                    this.apiList = this.platform.apiList;
                    this.filteredAPIList = [];
                        if (this.apiList && this.apiList.length) {
                            for (const api of this.apiList) {
                                if (api.executor_type !== 'API') {
                                    this.filteredAPIList.push(api);
                                }
                            }
                        } else {
                            this.apiList = [];
                        }
                        this.apiList = this.filteredAPIList;
                } else {
                    await this.platform.getApiDiscoveryData(this.partner, this.account);
                    if (this.platform.apiList !== null && this.platform.apiList !== undefined) {
                        this.apiList = this.platform.apiList;
                    } else {
                        this.platform.openSnackBar('Error while retriving API executors. Please try again sometime.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }

                this.confPost.getEntitiesForPartnerAccount(this.partner, this.account).subscribe(response => {
                    if (response) {
                        this.entities = response;
                        this.filteredEntities = response;
                    }
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Unable to retrieve entities for partner account.');
                });

                if (this.platform.b2bExecutors !== null && this.platform.b2bExecutors !== undefined) {
                    this.b2bAPIs = this.platform.b2bExecutors;
                    if (this.b2bAPIs && this.b2bAPIs.length) {
                        for (let i = 0; i < this.b2bAPIs.length; i++) {
                            for (let j = 0; j < this.b2bAPIs[i].categories.length; j++) {
                                for (let k = 0; k < this.b2bAPIs[i].categories[j].executors.length; k++) {
                                    this.b2bAPIsList.push(this.b2bAPIs[i].categories[j].executors[k]);
                                    this.filteredb2bAPIs.push(this.b2bAPIs[i].categories[j].executors[k]);
                                }
                            }
                        }
                    } else {
                        this.b2bAPIsList = [];
                        this.filteredb2bAPIs = [];
                    }
                    // if (this.platform.apiProducers !== null && this.platform.apiProducers !== undefined) {
                    //     this.apiProducers = this.platform.apiProducers;
                    //     this.getServiceProviders();
                    // } else {
                    //     await this.platform.getApiDiscoveryServiceProviders();
                    //     if (this.platform.apiProducers !== null && this.platform.apiProducers !== undefined) {
                    //         this.apiProducers = this.platform.apiProducers;
                    //         this.getServiceProviders();
                    //     } else {
                    //         this.platform.openSnackBar('Error while getting list of service providers for platform: ', 'Error', {
                    //             duration: 15000,
                    //             verticalPosition: 'top',
                    //             horizontalPosition: 'center'
                    //         });
                    //         this.loading = false;
                    //     }
                    // }
                    this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=services' + '&account=services').subscribe(platformProviders => {
                        this.serviceProviders = platformProviders;
                        this.platform.platformServiceProviders = platformProviders;
                        const iterator = this.serviceProviders[Symbol.iterator]();
                        while (true) {
                            const tempObject = iterator.next();
                            if (tempObject.done) {
                                break;
                            }
                            this.apiProducers.push(tempObject.value);
                        }
                        this.getServiceProviders();
                    }, error => {
                        this.platform.openSnackBar('Error while getting list of service providers for platform: ' + error.error.message, 'Error', {
                            duration: 15000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });
                } else {
                    this.getB2bAPIs();
                }
            }
        }));
        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            this.databases = this.platform.databases;
        } else {
            await this.platform.getDatabasesForPartnerAccount();
            this.databases = this.platform.databases;
        }

    }


    async getB2bAPIs() {
         Promise.resolve(this.platform.getb2bAPIs()).then(response => {
            this.b2bAPIs = this.platform.b2bExecutors;
            if (this.b2bAPIs && this.b2bAPIs.length) {
                for (let i = 0; i < this.b2bAPIs.length; i++) {
                    for (let j = 0; j < this.b2bAPIs[i].categories.length; j++) {
                        for (let k = 0; k < this.b2bAPIs[i].categories[j].executors.length; k++) {
                            this.b2bAPIsList.push(this.b2bAPIs[i].categories[j].executors[k]);
                            this.filteredb2bAPIs.push(this.b2bAPIs[i].categories[j].executors[k]);
                        }
                    }
                }
            } else {
                this.b2bAPIsList = [];
                this.filteredb2bAPIs = [];
            }
        });

        // if (this.platform.apiProducers !== null && this.platform.apiProducers !== undefined) {
        //     this.apiProducers = this.platform.apiProducers;
        //     this.getServiceProviders();
        // } else {
        //     await this.platform.getApiDiscoveryServiceProviders();
        //     if (this.platform.apiProducers !== null && this.platform.apiProducers !== undefined) {
        //         this.apiProducers = this.platform.apiProducers;
        //         this.getServiceProviders();
        //     } else {
        //         this.platform.openSnackBar('Error while getting list of service providers for platform: ', 'Error', {
        //                 duration: 15000,
        //                 verticalPosition: 'top',
        //                 horizontalPosition: 'center'
        //             });
        //         // this.loading = false;
        //     }
        // }
        this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=services' + '&account=services').subscribe(platformProviders => {
            this.serviceProviders = platformProviders;
            this.platform.platformServiceProviders = platformProviders;
            const iterator = this.serviceProviders[Symbol.iterator]();
            while (true) {
                const tempObject = iterator.next();
                if (tempObject.done) {
                    break;
                }
                this.apiProducers.push(tempObject.value);
            }
            this.getServiceProviders();
        }, error => {
            this.platform.openSnackBar('Error while getting list of service providers for platform: ' + error.error.message, 'Error', {
                duration: 15000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    getServiceProviders() {
        this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), true).subscribe(settingsData => {
            this.settingsData = settingsData;
            this.platform.settingsData = settingsData;
            if (this.partner !== 'services') {
                if (this.settingsData['body'][0]) {
                    this.subscribedTemp = this.settingsData['body'][0]['subscriptions']['providers'];
                    this.filteredSubscribedTemp = this.settingsData['body'][0]['subscriptions']['providers'];
                    let flag = false;
                    if (this.apiProducers) {
                        this.apiProducers.forEach(apiProducer => {
                            flag = false;
                            if (apiProducer && apiProducer.producer) {
                                if (this.subscribedTemp) {
                                    this.subscribedTemp.forEach(subscribedProducer => {
                                        if (subscribedProducer && subscribedProducer.producer) {
                                            if (subscribedProducer.producer === apiProducer.producer) {
                                                flag = true;
                                                this.serviceProviderImages[apiProducer.producer] = apiProducer.image;
                                            }
                                        }
                                    });
                                    if (flag === false) {
                                        this.available.push(apiProducer);
                                        this.filteredAvailable.push(apiProducer);
                                        this.serviceProviderImages[apiProducer.producer] = apiProducer.image;
                                    }
                                }
                            }
                        });
                    }
                }
            }
            this.checkFilter(this.searchText);
            // this.loading = false;
        }, error => {
            this.platform.openSnackBar('Error while getting list of settings data for partner: ' + error.error.message, 'Error', {
                duration: 15000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            // this.loading = false;
        });
    }


    getMethodClass(method) {
        switch (method) {
            case 'GET':
                return 'get';
            case 'PUT':
                return 'put';
            case 'POST':
                return 'post';
            case 'DELETE':
                return 'delete';
            case 'PATCH':
                return 'patch';
        }
    }

    getIconClass(type) {
        switch (type) {
            case 'API':
                return 'fa fa-table';
            case 'BUSINESSLOGIC':
                return 'fa fa-link';
            case 'SQLQUERY':
                return 'fa fa-database';
            case 'TESTSUITE':
                return 'fa fa-check-circle';
        }
    }

    findDependencies(api) {
        const executor = api.entity;
        const key = api.key;
        // let depKey = '#' + 'dependency' + key;
        // $(depKey).hasClass('hide') ? $(depKey).removeClass('hide') : $(depKey).addClass('hide');
        if (this.dependencies && !this.dependencies[key]) {
            if (executor.executor_name) {
                this.confPost.getDependenciesForExecutors(this.partner, this.account, executor.executor_name, executor.executor_version, this.partner, this.account).subscribe(response => {
                    if (response) {
                        this.dependencies[key] = [];
                        this.dependencies[key].push(this.setDependenciesForExecutor(response));
                        // setTimeout(() => {
                        //     $(depKey).removeClass('hide');
                        // }, 100);

                    }
                });
            } else {
                this.confPost.getDependenciesForEntities(this.partner, this.account, executor.entityname, executor.version, this.partner, this.account).subscribe(response => {
                    if (response) {
                        this.dependencies[key] = [];
                        this.dependencies[key].push(this.setDependenciesForEntity(response));
                        // setTimeout(() => {
                        //     $(depKey).removeClass('hide');
                        // }, 100);
                    }
                });
            }
        }
    }

    findUsages(API) {
        const api = API.entity;
        const key = API.key;
        // let usgKey = '#' + 'usages' + key;
        // $(usgKey).hasClass('hide') ? $(usgKey).removeClass('hide') : $(usgKey).addClass('hide');
        if (this.usages && !this.usages[key]) {
            if (api.executor_name) {
                this.confPost.getUsagesForAPI(this.partner, this.account, api.executor_name, api.executor_version).subscribe(response => {
                    this.usages[key] = response;
                    // setTimeout(() => {
                    //     $(usgKey).removeClass('hide');
                    // }, 100);
                });
            } else {
                this.confPost.getUsagesForEntity(this.partner, this.account, api.entityname, api.version).subscribe(response => {
                    this.usages[key] = response;
                    // setTimeout(() => {
                    //     $(usgKey).removeClass('hide');
                    // }, 100);
                });
            }
        }
    }

    setDependenciesForEntity(dependentAPI) {
        this.apiDependenciesList.push(dependentAPI.entity);
        const menuItem = {
            displayName: dependentAPI.entity.entityname,
            iconName: 'fa fa-table',
            type: 'entity',
            api: dependentAPI.entity,
            index: this.apiDependenciesList.length - 1,
        };
        if (dependentAPI.dependencies.length) {
            menuItem['children'] = [];
            for (const api of dependentAPI.dependencies) {
                menuItem['children'].push(this.setDependenciesForEntity(api));
            }
        }
        return menuItem;
    }

    setDependenciesForExecutor(dependentAPI) {
        if (dependentAPI['apiExecutor']) {
            this.apiDependenciesList.push(dependentAPI['apiExecutor']);
            // this.apiDeploymentStatus.push({
            //     deploying: false,
            //     deployed: 'loading',
            // });
        }
        const menuItem = {
            displayName: dependentAPI['apiExecutor'].executor_name,
            iconName: 'fa fa-link',
            type: 'executor',
            api: dependentAPI.apiExecutor,
            index: this.apiDependenciesList.length - 1,
        };
        // const isOverride = await this.checkForExistingAPI(dependentAPI['apiExecutor'].executor_name, dependentAPI['apiExecutor'].executor_version);
        // if (isOverride) {
        //     menuItem.override = true;
        // }
        //this.selectedAPIs.push(this.apiDependenciesList.length - 1);
        if (dependentAPI.entityDependencies.length || dependentAPI.executorDependencies.length) {
            menuItem['children'] = [];
            for (const api of dependentAPI.entityDependencies) {
                menuItem['children'].push(this.setDependenciesForEntity(api));
            }
            for (const api of dependentAPI.executorDependencies) {
                menuItem['children'].push(this.setDependenciesForExecutor(api));
            }
        }
        return menuItem;
    }

    resetDisplayLimits() {
        this.filteredAPIListLimit = 4;
        this.filteredb2bAPIListLimit = 4;
        this.filteredEntitiesListLimit = 4;
    }

    checkFilter(searchText) {
        // clearTimeout(this.typingTimer);
        // this.typingTimer = setTimeout(() => {
        const filterData = [];
        filterData.push({
            id: 0,
            itemName: 'executor_name'
        });
        filterData.push({
            id: 1,
            itemName: 'executor_version'
        });
        filterData.push({
            id: 2,
            itemName: 'service_provider'
        });
        filterData.push({
            id: 3,
            itemName: 'executor_category'
        });
        filterData.push({
            id: 4,
            itemName: 'executor_method_type'
        });
        this.resetDisplayLimits();
        const searchString = searchText.split(' ');
        this.filteredb2bAPIs = this.b2bAPIsList;
        for (const searchStr of searchString) {
            this.filteredb2bAPIs = this.filterPipe.transform(this.filteredb2bAPIs, searchStr, filterData);
        }
        this.filteredAPIList = this.searchByObject.transform(this.apiList, 'executor_name', this.searchText);
        this.filteredEntities = this.searchByObject.transform(this.entities, 'entityname', this.searchText);
        this.filteredSubscribedTemp = this.searchByObject.transform(this.subscribedTemp, 'title', this.searchText);
        this.filteredAvailable = this.searchByObject.transform(this.available, 'title', this.searchText);
        this.isSearching = false;
        //}, 2000);

    }


    viewMore(listToBeLimited) {
        // switch(listToBeLimited){
        //     case ""
        // }
        this[listToBeLimited] += 4;
    }


    serviceProvidersChanged() {
        // this.loading = true;
        // this.b2bAPIsList = [];
        // this.filteredb2bAPIs = [];
        // this.apiProducers = [];
        // this.available = [];
        // this.filteredAvailable = [];
        // this.getB2bAPIs();
    }

    getMethodName(method, entityname) {
        return method.toLowerCase() + entityname;
    }

    getVersion(val) {
        if (val) {
            const data = val.split('#');
            return data[1];
        }
    }

    hasExecutorViewPermission(partner, item) {
        if (item['executor_type'] === 'API') {
            return this.platform.hasAccountPermission('view:' + partner + '=>' + item.account_id + '=>' + item.executor_category + '=>' + item.executor_version);
        } else {
            return this.platform.hasAccountPermission('view:' + partner + '=>' + item.account_id + '=>' + item.executor_name + '=>' + item.executor_version);
        }
    }


    showDependenciesTab(api) {
        let currentData = {apitype: api, isDocTest: false, isMgmt: false, isEditDef: false, isUsages: false, isDependencies: true, tab_type: 'Dependencies'};
        const compareJSONObj = this.tabsData.findIndex(o => JSON.stringify(o.apitype) === JSON.stringify(currentData.apitype) && o.isDependencies === currentData.isDependencies);
        if (compareJSONObj === -1) {
            this.tabsData.push(currentData);
            this.activeTabIndex = this.tabsData.length - 1;
        } else {
            this.activeTabIndex = compareJSONObj;
        }
    }

    showUsagesTab(api) {
        let currentData = {apitype: api, isDocTest: false, isMgmt: false, isEditDef: false, isUsages: true, isDependencies: false, tab_type: 'Usages'};
        const compareJSONObj = this.tabsData.findIndex(o => JSON.stringify(o.apitype) === JSON.stringify(currentData.apitype) && o.isUsages === currentData.isUsages);
        if (compareJSONObj === -1) {
            this.tabsData.push(currentData);
            this.activeTabIndex = this.tabsData.length - 1;
        } else {
            this.activeTabIndex = compareJSONObj;
        }
    }

    makeDASEditDefVisible(entity) {
        let currentData = {apitype: entity.key, isDocTest: false, isMgmt: false, isEditDef: true, isUsages: false, isDependencies: false, tab_type: 'Edit Def'};
        const compareJSONObj = this.tabsData.findIndex(o => JSON.stringify(o.apitype) === JSON.stringify(currentData.apitype) && o.isEditDef === currentData.isEditDef);
        if (compareJSONObj === -1) {
            this.tabsData.push(currentData);
            this.activeTabIndex = this.tabsData.length - 1;
        } else {
            this.activeTabIndex = compareJSONObj;
        }
    }

    makeEditDefVisible(api) {
        let currentData = {apitype: api.key, isDocTest: false, isMgmt: false, isEditDef: true, isUsages: false, isDependencies: false, tab_type: 'Edit Def'};
        const compareJSONObj = this.tabsData.findIndex(o => JSON.stringify(o.apitype) === JSON.stringify(currentData.apitype) && o.isEditDef === currentData.isEditDef);
        if (compareJSONObj === -1) {
            this.tabsData.push(currentData);
            this.activeTabIndex = this.tabsData.length - 1;
        } else {
            this.activeTabIndex = compareJSONObj;
        }
    }

    showAPIMgmtTab(api) {
        let currentData = {apitype: api.key, isDocTest: false, isMgmt: true, isEditDef: false, isUsages: false, isDependencies: false, tab_type: 'API Management'};
        const compareJSONObj = this.tabsData.findIndex(o => JSON.stringify(o.apitype) === JSON.stringify(currentData.apitype) && o.isMgmt === currentData.isMgmt);
        if (compareJSONObj === -1) {
            this.tabsData.push(currentData);
            this.activeTabIndex = this.tabsData.length - 1;
        } else {
            this.activeTabIndex = compareJSONObj;
        }
    }

    showAPIDocTab(api) {
        let currentData = {apitype: api.key, isDocTest: true, isMgmt: false, isEditDef: false, isUsages: false, isDependencies: false, tab_type: 'Doc/Test'};
        const compareJSONObj = this.tabsData.findIndex(o => JSON.stringify(o.apitype) === JSON.stringify(currentData.apitype) && o.isDocTest === currentData.isDocTest);
        if (compareJSONObj === -1) {
            this.tabsData.push(currentData);
            this.activeTabIndex = this.tabsData.length - 1;
        } else {
            this.activeTabIndex = compareJSONObj;
        }
    }
    showMethodTab(api) {
        let currentData = {apitype: api.entity, isDocTest: false, isMgmt: false, isEditDef: false, isUsages: false, isDependencies: false, isMethod: true, executor_name: api.executor_name, method_type: api.method, tab_type: 'Method'};
        const compareJSONObj = this.tabsData.findIndex(o => JSON.stringify(o.apitype) === JSON.stringify(currentData.apitype) && o.isMethod === currentData.isMethod && o.executor_name === currentData.executor_name);
        if (compareJSONObj === -1) {
            this.tabsData.push(currentData);
            this.activeTabIndex = this.tabsData.length - 1;
        } else {
            this.activeTabIndex = compareJSONObj;
        }
    }
    closeTab(index) {
        switch (this.tabsData[index].tab_type) {
            case 'Edit Def':
                this.tabsData[index].isEditDef = false;
                this.tabsData.splice(index, 1);
                break;
            case 'API Management':
                this.tabsData[index].isMgmt = false;
                this.tabsData.splice(index, 1);
                break;
            case 'Doc/Test':
                this.tabsData[index].isDocTest = false;
                this.tabsData.splice(index, 1);
                break;
            case 'Usages':
                this.tabsData[index].isUsages = false;
                this.tabsData.splice(index, 1);
                break;
            case 'Dependencies':
                this.tabsData[index].isDependencies = false;
                this.tabsData.splice(index, 1);
                break;
            case 'Method':
                this.tabsData[index].isMethod = false;
                this.tabsData.splice(index, 1);
                break;
        }
        this.activeTabIndex = this.tabsData.length - 1;
    }

    APIsCreatedinApiplatform() {
        if (this.tabsData[this.activeTabIndex]) {
            this.tabsData[this.activeTabIndex]['apiFrom'] = 'APIs Created In Apiplatform';
        }
    }
    APIsFromServiceProviders() {
        if (this.tabsData[this.activeTabIndex]) {
            this.tabsData[this.activeTabIndex]['apiFrom'] = 'Service Providers';
        }
    }
    APIsFromDataAccessServices() {
        if (this.tabsData[this.activeTabIndex]) {
            this.tabsData[this.activeTabIndex]['apiFrom'] = 'Data Access Services';
        }
    }
    getApiIconClass(selectedTabType) {
        switch (selectedTabType) {
            case 'Edit Def':
                return 'fa fa-edit';
            case 'Usages':
                return 'fa fa-cogs';
            case 'Dependencies':
                return 'fa fa-simplybuilt';
            case 'API Management':
                return 'fa fa-cog';
            case 'Doc/Test':
                return 'fa fa-rocket';
        }
    }
}
